// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_6l-6";
export var headerCell = "_6l-2";
export var rowWrapper = "_6l-4";
export var stickyAggregationCell = "_6l-a";
export var stickyAggregationRow = "_6l-7";
export var stickyColumnCell = "_6l-9";
export var stickyColumnHeaderCell = "_6l-8";
export var table = "_6l-1";
export var virtualRowWrapper = "_6l-5";
export var virtualTableContainer = "_6l-0";
export var white = "_6l-3";